import resulter from "@/store/utils/resulter";
import conn from "@/store/utils/connection";
import metaAPI from "@/store/utils/api-route/metaAPI";
import state from "./state"
import listKeuanganBiaya from "./state";

const actions = {
	async fetchBetaFeature({commit}) {
		try {
			const res = await conn.get(metaAPI.betaFeatureOwnerAccess)
			if (!res.status) {
				throw(res)
			}
			if (res.data.status) {
				commit("setBetaFeatureOwnerAccess", res.data.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchKomplainQrisMenu({commit}) {
		try {
			const res = await conn.get(metaAPI.showQrisManagementMenu)
			if (!res.status) {
				throw(res)
			}
			if (res.data.status) {
				commit("setShowQrisManagementMenu", res.data.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchSapaan({commit}) {
		if (state.sapaan.length > 0) {
			return resulter.successResult()
		}
		try {
			const res = await conn.get(metaAPI.sapaan)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				var dataSapaan = []
				for (var i = 0; i < res.data.data.length; i++) {
					dataSapaan = [...dataSapaan, {
						id: res.data.data[i].id,
						text: res.data.data[i].sapaan,
						tipeSapaan: res.data.data[i].tipe_sapaan,
					}]
				}
				commit("setSapaan", dataSapaan)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchAgama({commit}) {
		if (state.agama.length > 0) {
			return resulter.successResult()
		}
		try {
			const res = await conn.get(metaAPI.agama)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				var dataAgama = []
				for (var i = 0; i < res.data.data.length; i++) {
					dataAgama = [...dataAgama, {
						id: res.data.data[i].id,
						text: res.data.data[i].nama_agama
					}]
				}
				commit("setAgama", dataAgama)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchKaryawanAll({commit, rootGetters}) {
		try {
			let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"]

			let query = {}
			if (getFilterItem.outlet.length > 0) {
				query.idoutlet = []
				getFilterItem.outlet.forEach((outlet) => {
					query.idoutlet = [...query.idoutlet, outlet]
				})
			}
			const res = await conn.get(metaAPI.karyawan, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setKaryawanAll", res)
				return resulter.successResult('', res.data.data)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchKonsumen({commit}, {searchKey}) {
		try {
			let query = {
				key : searchKey
			}
			const res = await conn.get(metaAPI.listKonsumenV2, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setKonsumen", res)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchKonsumenTiny({commit}, {searchKey}) {
		try {
			let query = {
				key : searchKey,
				limit: 100,
			}
			const res = await conn.get(metaAPI.listKonsumenTiny, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setKonsumenTiny", res)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchTahapan({commit}) {
		if (state.tahapan.length > 0) {
			return resulter.successResult()
		}
		try {
			const res = await conn.get(metaAPI.tahapan)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setTahapan", res)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchMesinAll({commit, rootGetters}) {
		try {
			let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"]

			let query = {}
			if (getFilterItem.outlet.length > 0) {
				query.idoutlet = []
				getFilterItem.outlet.forEach((outlet) => {
					query.idoutlet = [...query.idoutlet, outlet]
				})
			}
			const res = await conn.get(metaAPI.mesin, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setMesinAll", res)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchAkunKeuangan({commit}, idoutlet) {
		try {
			let query = {
				idoutlet: idoutlet
			}
			const res = await conn.get(metaAPI.akunKeuangan, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setAkunKeuangan", res)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchAkunKeuanganIdtransaksi({commit}, payload) {
		try {
			let query = {
				idoutlet: payload.idoutlet,
				idtransaksi: payload.idtransaksi,
				transaksi_type: payload.type,
			}
			const res = await conn.get(metaAPI.akunKeuangan, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setAkunKeuangan", res)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchAkunDebit({commit}, idoutlet) {
		try {
			const res = await conn.get(metaAPI.akunDebit)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setAkunDebit", res)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchWorkshopAllTiny({commit}, idoutlet) {
		try {
			const res = await conn.get(metaAPI.workshop)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setWorkshop", res)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchAkunKeuanganGlobal({commit}, idoutlet) {
		try {
			const res = await conn.get(metaAPI.akunKeuanganGlobal)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setAkunKeuanganGlobal", res)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchFinancialAccountFund({commit}, idoutlet) {
		try {
			const res = await conn.get(metaAPI.listFinancialAccountFund)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setFinancialAccountFund", res)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchAssetsAccount({commit}, idoutlet) {
		try {
			const res = await conn.get(metaAPI.listAssetsAccount)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setListAssetsAccount", res)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchListKeuanganKasOutlet({commit}) {
		try {
			const res = await conn.get(metaAPI.listKeuanganKasOutlet)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setListKeuanganKasOutlet", res)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchListKeuanganKasWorkshop({commit}) {
		try {
			const res = await conn.get(metaAPI.listKeuanganKasWorkshop)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setListKeuanganKasWorkshop", res)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchListKeuanganBiaya({commit}) {
		try {
			const res = await conn.get(metaAPI.listKeuanganBiaya)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setListKeuanganBiaya", res)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchListKeuanganOwner({commit}) {
		try {
			const res = await conn.get(metaAPI.listKeuanganOwner)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setListKeuanganOwner", res)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchListBiayaItemKategori({commit}, id) {
		try {
			let query = {
				idakun_biaya: id
			}
			const res = await conn.get(metaAPI.listBiayaItemKategori, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setListBiayaItemKategori", res)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
  async fetchDataMCoin({ commit }) {
    try {
      const res = await conn.get(metaAPI.dataMCoin);
      if (!res.data) {
        throw(res)
      }
      if (res.data.status) {
        commit("setDataMCoin", res.data)
      } else {
				return resulter.errorResult(res.data.msg)
			}
    } catch (e) {
			return resulter.errorResult(e)
		}
  },
  async getShortcode(state, {searchKey, category}) {
    let query = {
				key: searchKey
		}

    return conn.get(`${metaAPI.getShortcode}/${category}`, query);
  },
  setShortcode({commit}, payload) {
    commit("setShortcode", payload);
  },
	async fetchAkunEDC({commit}, idoutlet) {
		try {
			const res = await conn.get(metaAPI.akunEDC)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setAkunDebit", res)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
  /**
   *
   * @param {*} type INT 1 | 2 | 3
   * 1 => pengumuman
   * 2 => alert
   * 3 => banner
   *
   * empty => show all
   * @returns promise response
   */
  async getDahsboardInfo({commit}, {type}) {
    let query = {
      type
    }

    return conn.get(metaAPI.getDahsboardInfo, query)
  },
	async fetchTopServiceSummary({commit}, payload) {
		try {
			const res = await conn.post(metaAPI.topServiceSummary, payload)
			if (!res.status) {
				throw(res)
			}
			if (res.data.status) {
				commit("setTopServiceSummary", res.data.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
}

export default actions